import { render, staticRenderFns } from "./ItemSelect_List.vue?vue&type=template&id=38e60c2e&"
import script from "./ItemSelect_List.vue?vue&type=script&lang=js&"
export * from "./ItemSelect_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports